import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import Services from '../components/Services';
import Manifesto from '../components/Manifesto';
import Portfolio from '../components/Portfolio';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import Insights from '../components/Insights';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import LiveChat from '../components/LiveChat';

export default function Landing() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Portfolio />
        <Testimonials />
        <Pricing />
        <Insights />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <LiveChat />
    </>
  );
}
